/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneBlip as ResolvedStandaloneBlip } from 'base/components/standalone/Blip';

export const Blip: typeof ResolvedStandaloneBlip = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneBlip {...props} />
    );
});

export type BlipProps = PropsFromComponent<typeof Blip>;

/** @deprecated Use slot architecture instead */
export const BlipWith = (extras: DynamicStandaloneExtras): typeof Blip => {
    return function Blip(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Blip');
        return <ResolvedStandaloneBlip {...mergeProps({ options: { theme } }, props)} />;
    }
}